
















































import { Component, Vue } from "vue-property-decorator";
import { deleteChannel, checkDelete } from "@/services/channels/channelsService";

@Component
export default class ChannelDeleteModal extends Vue {
    channelToBeDeleted: string = "";
    channelName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.channelToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.channelToBeDeleted = "";
        this.channelName = "";
    }

    open(channelId: string, name: string) {
        checkDelete(channelId).then(response => {
            if (response) {
                this.channelToBeDeleted = channelId;
                this.channelName = name;
                this.$bvModal.show("modal-deleteChannel");
            } else {
                this.$bvModal.show("modal-deleteChannelNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteChannelNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteChannel");
        this.channelToBeDeleted = "";
        this.channelName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteChannel(this.channelToBeDeleted).then(() => {
            this.$emit("reload");
            this.channelToBeDeleted = "";
            this.channelName = "";
            this.$bvModal.hide("modal-deleteChannel");
        });
    }
}
